export const modalMessages = {
  both:
    "Si realizas Reserva sin abono, quedará confirmada una vez des click en el botón y de ser necesario el Centro Deportivo se comunicará contigo.\n\nSi realizas Reserva con abono, tendrás 15 minutos para realizar el pago, de lo contrario tu reserva NO quedará confirmada.",
  reservationWithCreditMemo:
    "Una vez inicies el proceso de reserva, tendrás 15 minutos para realizar el pago, de lo contrario tu reserva NO quedará confirmada.",
  reservationWithoutCreditMemo:
    "Una vez hagas click en el botón de Reserva sin abono, tu reserva queda confirmada y de ser necesario el Centro Deportivo se comunicará contigo.",
  classReservationWithCreditMemo:
    "Una vez inicies el proceso de inscripción, tendrás 15 minutos para realizar el pago, de lo contrario tu inscripción NO quedará confirmada.",
};
